module.exports = __webpack_public_path__ + "img/考试管理.00277beb.svg";